import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const AllSet = () => {
  return (
    <Wrapper>
      <section className="content">
        <div className="pink-line" />
        <h2>All set? Let’s double check that real quick</h2>
        <Link to="#" className="btn btn-main">SEO CHECK</Link>
      </section>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  padding: 160px 0;
  text-align: center;
  .pink-line{border-top: 3px solid var(--clr-primary-2); width: 10vw; margin: 0 auto 30px;}
  .content {
    padding: 2.7rem 18px 2.7rem 18px;
    background: var(--clr-white);
    box-shadow: var(--light-shadow);
  }
  h2 {
    font-size: 30px;
    line-height: 47px;
  }
  .btn {
    margin-top: 38px;
    border: 2px solid var(--clr-red-dark);
    display: block;
    
  }
  @media screen and (min-width: 568px) {
    .content {
      padding: 2.7rem 69px 2.7rem 69px;
    }
    .btn {
      display: inline-block;
    }
  }
  @media screen and (min-width: 768px) {
    .content {
      padding: 60px 69px 60px 69px;
    }
  }
  @media screen and (min-width: 1025px) {
    
    .content {
      border-radius: 10px;
      margin: 0 auto;
      padding: 2.7rem 2.7rem 2.7rem 3.5rem;
      width: 93vw;
      max-width: 1360px;
    }
    h2 {
      font-size: 40px;
    }
    .btn {
      margin-top: 1.78rem;
      padding: 1.2rem 4rem;
      text-transform: none;
      font-size: 16px;
      border-radius: 10px;
    }
  }
`

export default AllSet
